import { Routes } from '@angular/router';
import { RedirectComponent } from 'src/core/components/redirect/redirect.component';
import { authGuard } from 'src/core/guards';
import { coreRoutesNames } from './core.routes.names';

export const coreRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: RedirectComponent,
  },
  {
    path: coreRoutesNames.AUTH,
    loadChildren: () =>
      import('./auth/auth.routes').then((module) => module.authRoutes),
  },
  {
    path: coreRoutesNames.PROFILE,
    loadChildren: () =>
      import('./profile/profile.routes').then((module) => module.profileRoutes),
  },
  {
    path: coreRoutesNames.DASHBOARD,
    canMatch: [authGuard],
    loadChildren: () =>
      import('./dashboard/dashboard.routes').then(
        (module) => module.dashboardRoutes,
      ),
  },
  /*
  {
    path: appRoutesNames.NEWS,
    canMatch: [authGuard],
    loadChildren: () =>
      import('./news/news.routes').then((module) => module.newsRoutes),
  },
  */
  {
    path: coreRoutesNames.USERS,
    canMatch: [authGuard],
    loadChildren: () =>
      import('./users/users.routes').then((module) => module.usersRoutes),
  },
  {
    path: '**',
    loadChildren: () =>
      import('./not-found/not-found.routes').then(
        (module) => module.notFoundRoutes,
      ),
  },
];
